import { TextArea } from "components/ui/inputs/TextArea"
import style from "./NotesSection.module.scss"

const { section, label, textareaWrapper } = style

type Props = {
	value: string
	onChange: (value: string) => void
	onBlur?: () => void
}

export const NotesSection = ({ value, onChange, onBlur }: Props) => {
	return (
		<div className={section}>
			<span className={label}>Notes</span>
			<div className={textareaWrapper}>
				<TextArea
					value={value}
					placeholder="Describe the item: materials, specs, special requirements"
					minRows={4}
					onChange={(e) => onChange(e.target.value)}
					onBlur={onBlur}
				/>
			</div>
		</div>
	)
}
